import { useEffect, useState } from "react";
import * as actions from "../../../../Redux/Actions/index";
import { useDispatch } from "react-redux";
import { Dropdown, InputGroup, Spinner, Button } from "react-bootstrap";
import { BsCheckLg, BsXLg, BsGear } from "react-icons/bs"; 
import {
  showErrorToastMessage,
  showSuccessToastMessage,
} from "../../../../component/Toasts/Toasts";
import {
  Strings,
  empBasicDetailsValidations,
} from "../../../../constant/Strings";
import { departmentValidation, containsInvalidChars } from "../../../../constant/Validations";

const EditBasicDetails = (props: any) => {
  const {
    eCode,
    dateOfJoining,
    department,
    departmentRef,
    subDepartment,
    subDepartmentRef,
    designation,
    handleEditBasicDetails,
    eId,
    apiCallCompleted
  } = props;
  const {
    editSuccess,
    e_code,
    cancel,
    submit,
    designationLabel,
    date_of_joining,
    departmentLabel,
    invalidCharsError
  } = Strings;
  const { departmentValid } = empBasicDetailsValidations;

  const dispatch = useDispatch();

  const [employeeData, setEmployeeData] = useState({
    eCode: eCode,
    dateOfJoining: dateOfJoining,
    department: department,
    departmentRef: departmentRef || "",
    subDepartment: subDepartment || "",
    subDepartmentRef: subDepartmentRef || "",
    designation: designation,
    eId: eId,
    updatedBy: eId,
  });

  const [deptOptions, setDeptOptions] = useState<any[]>([]);
  const [subDeptOptions, setSubDeptOptions] = useState<any[]>([]);
  
  const [errors, setErrors] = useState({ department: "", subDepartment: "" });
  const [btnDisable, setBtnDisable] = useState(false);

  useEffect(() => {
    dispatch(actions.getAllDepartmentsAction((res: any) => {
      if (res?.data) setDeptOptions(res.data);
    }));
  }, [dispatch]);

  // Load Sub-Departments
  useEffect(() => {
    const selectedDept = deptOptions.find(d => 
        d._id === employeeData.departmentRef || 
        d.departmentName === employeeData.department
    );

    if (selectedDept) {
      console.log("🔄 Fetching Sub-Depts for:", selectedDept.departmentName);
      dispatch(actions.getSubDepartmentsByParentAction(selectedDept._id, (res: any) => {
        if (res?.data) {
            console.log("✅ Sub-Depts Loaded:", res.data);
            setSubDeptOptions(res.data);
        }
      }));
    } else {
        setSubDeptOptions([]);
    }
  }, [employeeData.department, deptOptions, dispatch]);

  // Validation
  useEffect(() => {
    if (employeeData.department && employeeData.subDepartment) {
      setBtnDisable(true);
    } else {
      setBtnDisable(false);
    }
  }, [employeeData]);

  const handleEdit = () => {
    // Basic validation logic...
    apiCallCompleted(false);
    dispatch(
      actions.editEmployeeDataAction(employeeData, (res: any) => {
        if (res?.code === 200) {
          showSuccessToastMessage(editSuccess);
          apiCallCompleted(true);
        } else {
          showErrorToastMessage(res?.error?.error_description || "Error");
          apiCallCompleted(true);
        }
      })
    );
    handleEditBasicDetails();
  };

  return (
    <div>
      <div className="row g-4">
        {/* E-Code */}
        <div className="col-md-4">
          <label className="form-label">{e_code}</label>
          <input disabled type="text" className="form-control" value={employeeData.eCode} />
        </div>

        {/* Date of Joining */}
        <div className="col-md-4">
          <label className="form-label">{date_of_joining}</label>
          <input disabled type="date" className="form-control" 
            value={employeeData.dateOfJoining} 
            onChange={(e)=>setEmployeeData({...employeeData, dateOfJoining: e.target.value})}
          />
        </div>

        {/* Department Dropdown */}
        <div className="col-md-4">
          <label className="form-label">{departmentLabel}</label>
          <Dropdown onSelect={(key: any) => {
                const selectedObj = deptOptions.find(d => d.departmentName === key);
                console.log("🔽 Department Selected:", key);
                setEmployeeData({
                    ...employeeData,
                    department: key,
                    departmentRef: selectedObj ? selectedObj._id : "",
                    subDepartment: "", 
                    subDepartmentRef: ""
                });
            }}>
              <Dropdown.Toggle variant="light" className="form-control text-start d-flex justify-content-between align-items-center">
                {employeeData.department || "Select..."}
              </Dropdown.Toggle>
              <Dropdown.Menu className="w-100" style={{maxHeight: '200px', overflowY: 'auto'}}>
                 {deptOptions.map((opt: any) => (
                    <Dropdown.Item key={opt._id} eventKey={opt.departmentName}>{opt.departmentName}</Dropdown.Item>
                 ))}
              </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* Sub-Department Dropdown */}
        <div className="col-md-4">
          <label className="form-label">Sub Department</label>
          <Dropdown onSelect={(key: any) => {
                console.log("🔽 Sub-Department Selected:", key);
                const selectedObj = subDeptOptions.find(d => d.subDepartmentName === key);
                setEmployeeData({
                    ...employeeData,
                    subDepartment: key,
                    subDepartmentRef: selectedObj ? selectedObj._id : ""
                });
            }}>
              <Dropdown.Toggle variant="light" className="form-control text-start d-flex justify-content-between align-items-center"
                disabled={!employeeData.department}
              >
                {employeeData.subDepartment || "Select..."}
              </Dropdown.Toggle>
              <Dropdown.Menu className="w-100" style={{maxHeight: '200px', overflowY: 'auto'}}>
                 {subDeptOptions.length > 0 ? (
                    subDeptOptions.map((opt: any) => (
                        <Dropdown.Item key={opt._id} eventKey={opt.subDepartmentName}>{opt.subDepartmentName}</Dropdown.Item>
                    ))
                 ) : (
                    <Dropdown.Item disabled>No Sub-Departments</Dropdown.Item>
                 )}
              </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* Designation */}
        <div className="col-md-4">
          <label className="form-label">{designationLabel}</label>
          <input disabled type="text" className="form-control" value={employeeData.designation} />
        </div>
      </div>

      <div className="modal-btn-wrapper mt-4 mb-4">
        <button className="btn cancel-btn buttonsize" onClick={handleEditBasicDetails}>{cancel}</button>
        <button className={btnDisable ? "btn add-submit-button buttonsize" : "btn add-submit-button btn-disabled buttonsize"} onClick={handleEdit}>{submit}</button>
      </div>
    </div>
  );
};

export default EditBasicDetails;